export class DialogResult<T> {
  private constructor(
    private readonly _status: 'success' | 'cancelled',
    private readonly _data?: T
  ) {}

  static success<T>(data?: T): DialogResult<T> {
    return new DialogResult('success', data);
  }

  static cancelled<T>(): DialogResult<T> {
    return new DialogResult('cancelled');
  }

  success(): boolean {
    return this._status === 'success';
  }

  cancelled(): boolean {
    return this._status === 'cancelled';
  }

  getData(): T | undefined {
    return this._data;
  }
}
